/// <reference types="jquery" />
export { App3D, ItemConfig, PropertyDetail, Navigator } from "./app3D/App3D";

// require("expose-loader?$!jquery");
require("expose-loader?App3D!./app3D/App3D");



// WEBPACK FOOTER //
// ./src/script/app3D-wrapper.ts